import { IPost, UserProfile } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { ErrorBoundary } from '../../ui';
import { createUserServiceClient } from '../../utils/apiClientFactory';
import { seeAllPressedForInsights } from '../actions';
import { BlogPostSlider } from './BlogPostSlider';

interface IProps {
  posts: IPost[];
  allLoading: boolean;
  moreLoading: boolean;
  showSeeMoreButton: boolean;
  failedToLoadInsightBlogs: boolean;
  seeMoreInsightsPressed: () => void;
  userProfile: UserProfile;
  t: (key: string) => string;
}

class InsightBlogPosts extends PureComponent<IProps> {
  public render() {
    const {
      t,
      allLoading,
      moreLoading,
      posts,
      showSeeMoreButton,
      seeMoreInsightsPressed,
      failedToLoadInsightBlogs,
    } = this.props;

    if (failedToLoadInsightBlogs) {
      return <></>;
    }

    return (
      <ErrorBoundary childTreeName={'Insight Blog Posts'}>
        <BlogPostSlider heading={t('dashboard:insights')}
                        posts={posts}
                        loading={allLoading}
                        seeMoreLoading={moreLoading}
                        seeMorePressed={seeMoreInsightsPressed}
                        seeMoreCardText={t('dashboard:seeAllInsights')}
                        showSeeMoreButton={showSeeMoreButton}
        />
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state) => ({
  posts: state.summaryDashboard.data.insightBlogs,
  allLoading: state.summaryDashboard.view.insightBlogPostsLoading,
  failedToLoadInsightBlogs: state.summaryDashboard.view.insightBlogPostsFailure,
  moreLoading: state.summaryDashboard.view.seeAllInsightsLoading,
  showSeeMoreButton: !state.summaryDashboard.view.isSeeAllInsights,
});

const mapDispatchToProps = (dispatch, ownProps: IProps) => {
  const userServiceClient = createUserServiceClient();
  return {
    seeMoreInsightsPressed: () => dispatch(seeAllPressedForInsights(userServiceClient, ownProps.userProfile)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InsightBlogPosts);
